import { blue, blueGrey, cyan, green, indigo, orange, pink, teal } from "@mui/material/colors";

export const COLOR_CHIPS = [
  { color: "#8E42CA", backgroundColor: "#F4ECFB" },
  { color: orange[900], backgroundColor: orange[100] },
  { color: blue[900], backgroundColor: blue[100] },
  { color: green[900], backgroundColor: green[100] },
  { color: blueGrey[900], backgroundColor: blueGrey[100] },
  { color: indigo[900], backgroundColor: indigo[100] },
  { color: cyan[900], backgroundColor: cyan[100] },
  { color: pink[900], backgroundColor: pink[100] },
  { color: teal[900], backgroundColor: teal[100] },
];

export const CUSTOM_COLORS = {
  pink: {
    500: "#E91E63",
  },
  purple: {
    200: "#EADBF9",
    300: "#DABFF3",
    400: "#C397E9",
    500: "#AB6EDE",
    600: "#8E42CA",
    700: "#803DB3",
    800: "#6C3693",
  },
  grey: {
    300: "#C0C8D0",
    400: "#A1ACB9",
    500: "#8A95A7",
    600: "#798397",
    700: "#6C7489",
  },
  orange: {
    600: "#FF8F00",
    700: "#F57C00",
  },
  red: {
    400: "#EF5350",
    500: "#F44336",
    600: "#E53935",
  },
  yellow: {
    600: "#FDD835",
  },
};
